/* ============================================================
   SAJ · CLIENT REVIEW FIXES 3 — "Website View Changes" (Aug 2026)
   Loaded from snippets/saj-head.liquid after saj-fixes.js / saj-fixes2.js.
   Everything here is additive and idempotent — no template, section
   setting or uploaded asset is touched.
   ============================================================ */
(function () {
  'use strict';
  if (window.__sajFix3) return;
  window.__sajFix3 = true;

  var d = document, de = d.documentElement;
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  /* ==========================================================
     1 / 2 · GOLD vs SILVER SEARCH
     Sri Anu (gold) pages search gold + diamond only; Menaxi (silver)
     pages search everything else. Gold and diamond pieces carry an
     exact "Gold" / "Diamond" tag — 1,165 of 7,239 products — so the
     split is a tag filter appended to the storefront query.
     ========================================================== */
  var GOLD = '(tag:Gold OR tag:Diamond)';
  var SILV = 'NOT tag:Gold AND NOT tag:Diamond';
  var SCOPE_RE = /\s+AND\s+(?:\(tag:Gold OR tag:Diamond\)|NOT tag:Gold AND NOT tag:Diamond)\s*$/i;

  function bare(q) { return String(q == null ? '' : q).replace(SCOPE_RE, '').trim(); }

  function world() {
    var q = '';
    try { q = new URLSearchParams(location.search).get('q') || ''; } catch (e) {}
    if (/NOT tag:Gold/i.test(q)) return SILV;              // already on a silver results page
    if (/tag:Gold OR tag:Diamond/i.test(q)) return GOLD;   // already on a gold results page
    return de.classList.contains('saj-menaxi-page') ? SILV : GOLD;
  }

  function scope(q) { var b = bare(q); return b ? b + ' AND ' + world() : b; }

  // every search form on the page (header, mobile drawer, search hero)
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    if ((f.getAttribute('action') || '').indexOf('/search') === -1) return;
    var inp = f.querySelector('input[name=q]');
    if (!inp) return;
    var s = scope(inp.value);
    if (s) inp.value = s;
  }, true);

  // popular-search chips and the "See all results" link (incl. ones injected later)
  d.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/search"]') : null;
    if (!a) return;
    try {
      var u = new URL(a.href, location.origin);
      var q = u.searchParams.get('q');
      if (!q) return;
      var s = scope(q);
      if (!s || s === q) return;
      u.searchParams.set('q', s);
      a.setAttribute('href', u.pathname + u.search);
    } catch (err) {}
  }, true);

  // the header's predictive dropdown talks to /search/suggest.json — scope that too
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        if (url && url.indexOf('/search/suggest') > -1) {
          var u = new URL(url, location.origin);
          var q = u.searchParams.get('q');
          var s = q ? scope(q) : '';
          if (s && s !== q) {
            u.searchParams.set('q', s);
            input = typeof input === 'string' ? (u.pathname + u.search) : new Request(u.toString(), input);
          }
        }
      } catch (e) {}
      return origFetch.call(this, input, init);
    };
  }

  // a /search URL typed, bookmarked or arrived at from Google carries no scope —
  // send it to the scoped equivalent once. The rewritten q is already scoped, so
  // this cannot run twice.
  function scopeBareSearchUrl() {
    if (location.pathname.indexOf('/search') !== 0) return false;
    var u;
    try { u = new URL(location.href); } catch (e) { return false; }
    var q = u.searchParams.get('q');
    if (!q || bare(q) !== q) return false;
    u.searchParams.set('q', scope(q));
    location.replace(u.toString());
    return true;
  }

  // the filter is machinery, not something a shopper should read
  function cleanSearchDisplay() {
    if (location.pathname.indexOf('/search') !== 0) return;
    var q = '';
    try { q = new URLSearchParams(location.search).get('q') || ''; } catch (e) {}
    var b = bare(q);
    if (!q || b === q) return;
    $$('.srch-hero h1 em').forEach(function (el) { el.textContent = '“' + b + '”'; });
    $$('input[name=q]').forEach(function (i) { if (bare(i.value) !== i.value) i.value = b; });
    if (d.title.indexOf(q) > -1) d.title = d.title.split(q).join(b);
    crossWorldHint(b);
  }

  // scoping the results can legitimately return nothing — e.g. searching
  // "silver" on the Sri Anu side. Offer the other catalogue rather than a
  // dead end.
  function crossWorldHint(term) {
    var empty = d.querySelector('.srch-empty');
    if (!empty || empty.querySelector('.saj-xworld') || !term) return;
    var silver = world() === SILV;
    var a = d.createElement('a');
    a.className = 'saj-xworld';
    a.href = '/search?type=product&q=' + encodeURIComponent(term + ' AND ' + (silver ? GOLD : SILV));
    a.textContent = silver
      ? 'Look for “' + term + '” in Sri Anu gold & diamond →'
      : 'Look for “' + term + '” in the Menaxi silver collection →';
    empty.appendChild(a);
  }

  /* ==========================================================
     1 / 2 (follow-through) · popular-search chips
     The chip list is shared by both brands, so on the Sri Anu side the
     silver chips would now return nothing (and vice versa). Hide the ones
     that cannot answer in the world the shopper is standing in.
     ========================================================== */
  var OTHER_WORLD = /\bsilver\b|menaxi/i;
  var THIS_WORLD = /\bgold\b|\bdiamond/i;
  function trimChips() {
    var silver = world() === SILV;
    $$('.srch-chips a, .saj-sugg .chip, .saj-search-panel .chip').forEach(function (a) {
      var t = a.textContent || '';
      if (/see all results/i.test(t)) return;
      var wrong = silver ? THIS_WORLD.test(t) : OTHER_WORLD.test(t);
      a.style.display = wrong ? 'none' : '';
    });
  }

  /* ==========================================================
     10 · the finder quiz opened by itself on every page, including
     over search results. Keep it as a welcome on the home page only;
     everywhere else it opens only when someone actually asks for it.
     ========================================================== */
  var lastClick = 0;
  d.addEventListener('click', function () { lastClick = Date.now(); }, true);
  function tameQuiz() {
    if (location.pathname === '/' || location.pathname === '') return;
    var S = window.SAJ;
    if (!S || typeof S.openQuiz !== 'function' || S.openQuiz.__sajTamed) return;
    var real = S.openQuiz;
    function tamed() {
      // a genuine click is at most a moment old; the auto-open timer is not
      if (Date.now() - lastClick < 1500) return real.apply(this, arguments);
    }
    tamed.__sajTamed = true;
    S.openQuiz = tamed;
  }

  /* ==========================================================
     4 · SILVER PDPs — no price breakup, no product details
     ========================================================== */
  function hideSilverBreakup() {
    if (location.pathname.indexOf('/products/') === -1) return;
    var card = d.querySelector('.saj-pbk');
    var badges = d.querySelector('.gal4-badges');
    if (!card || !badges) return;                 // no verdict to read → leave it alone
    var gold = $$('.gal4-badges .gb b').some(function (b) { return /BIS\s*916/i.test(b.textContent || ''); });
    card.style.display = gold ? '' : 'none';
  }

  /* ==========================================================
     6 / 19 · BESTSELLERS must not open with sold-out pieces
     ========================================================== */
  function trimSoldOutBestsellers() {
    $$('.saj-scope h2, .saj-scope .sec-h').forEach(function (h) {
      if (!/best\s*sell/i.test(h.textContent || '')) return;
      var sec = h.closest('section') || h.closest('.saj-scope');
      if (!sec) return;
      var cards = $$('.pc2', sec);
      var oos = cards.filter(function (c) { return c.classList.contains('is-oos'); });
      if (!oos.length || cards.length - oos.length < 2) return;  // never empty the row
      oos.forEach(function (c) { c.classList.add('saj-hide-oos'); });
    });
  }

  /* ==========================================================
     19 · slider arrows laid over the product rail
     ========================================================== */
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="';
  function railArrows() {
    $$('[data-slv-track]').forEach(function (track) {
      if (track.dataset.sajArrows || track.classList.contains('is-grid')) return;
      track.dataset.sajArrows = '1';
      var wrap = d.createElement('div');
      wrap.className = 'slv-railwrap';
      track.parentNode.insertBefore(wrap, track);
      wrap.appendChild(track);

      function make(cls, label, path, dir) {
        var b = d.createElement('button');
        b.type = 'button';
        b.className = 'slv-ar ' + cls;
        b.setAttribute('aria-label', label);
        b.innerHTML = ARROW + path + '"/></svg>';
        b.addEventListener('click', function () {
          track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.85, 160), behavior: 'smooth' });
        });
        wrap.appendChild(b);
        return b;
      }
      var prev = make('slv-ar-prev', 'Previous', 'M15 5l-7 7 7 7', -1);
      var next = make('slv-ar-next', 'Next', 'M9 5l7 7-7 7', 1);

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = max <= 0 || track.scrollLeft >= max;
      }
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ==========================================================
     15 · reels on mobile — one per screen, arrows on the video
     Moves the existing nav (keeping its click handlers) rather than
     cloning it, and moves it back if the window grows again.
     ========================================================== */
  var mqReel = window.matchMedia('(max-width:640px)');
  function reelsNav() {
    $$('[data-saj-igx]').forEach(function (sec) {
      var row = sec.querySelector('[data-igx-row]');
      var nav = sec.querySelector('.igx-nav');
      if (!row || !nav) return;
      var wrap = row.parentNode;
      if (!wrap.classList.contains('igx-rowwrap')) {
        wrap = d.createElement('div');
        wrap.className = 'igx-rowwrap';
        row.parentNode.insertBefore(wrap, row);
        wrap.appendChild(row);
        sec.__navHome = nav.parentNode;
        sec.__navAfter = nav.nextSibling;
      }
      if (mqReel.matches) {
        if (nav.parentNode !== wrap) { wrap.appendChild(nav); }
        nav.classList.add('igx-on-media');
      } else if (nav.parentNode === wrap && sec.__navHome) {
        sec.__navHome.insertBefore(nav, sec.__navAfter);
        nav.classList.remove('igx-on-media');
      }
    });
  }

  /* ==========================================================
     7 · "All Categories" is a permanent pill, never the active item
     ========================================================== */
  function unmarkAllCat() {
    $$('.saj-nav-row > li.saj-allcat.is-on').forEach(function (li) {
      li.classList.remove('is-on');
      var a = li.querySelector('a');
      if (a) a.removeAttribute('aria-current');
    });
  }

  /* ==========================================================
     12 · drawer badge copy — "Free" shipping was never the policy
     ========================================================== */
  function fixDrawerCopy() {
    $$('.dr2-b small, .dr2-b b').forEach(function (el) {
      var t = el.textContent || '';
      if (/free shipping/i.test(t)) el.textContent = t.replace(/free shipping/i, 'Secure Shipping');
    });
  }

  /* ==========================================================
     20 · mobile drawer / mega panels left open when the window grows
     ========================================================== */
  var mqDesk = window.matchMedia('(min-width:901px)');
  function closeMobileUI() {
    if (!mqDesk.matches) return;
    try { if (window.SAJ && SAJ.closeAll) SAJ.closeAll(); } catch (e) {}
    $$('#saj-drawer, #saj-cart, #saj-ov, .saj-drawer, .saj-drawer2, .saj-ov').forEach(function (el) {
      el.classList.remove('open');
    });
    $$('.saj-nav-row > li.open').forEach(function (li) { li.classList.remove('open'); });
    d.body.style.overflow = '';
  }

  /* ---------- run, and re-run when the theme re-renders ---------- */
  function run() {
    if (scopeBareSearchUrl()) return;   // navigating away, nothing else to do
    tameQuiz();
    cleanSearchDisplay();
    trimChips();
    hideSilverBreakup();
    trimSoldOutBestsellers();
    railArrows();
    reelsNav();
    unmarkAllCat();
    fixDrawerCopy();
  }
  function onMq(mq, fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }
  onMq(mqReel, reelsNav);
  onMq(mqDesk, closeMobileUI);
  window.addEventListener('resize', closeMobileUI);
  d.addEventListener('shopify:section:load', run);

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run);
  else run();
  // the pricing app and the cart drawer render late — catch those too
  setTimeout(run, 900);
  setTimeout(run, 2600);
})();
